import * as HttpService from './HttpService'

let namespace = 'project-statuses'

let findAll = (params, cb, errorCb) => {
    HttpService.get(namespace, params, cb, errorCb)
}

let statusTypes = (params, cb, errorCb) => {
    HttpService.get('status-types', params, cb, errorCb)
}

let update = (uuid, body, cb, errorCb) => {
    HttpService.patch(namespace + '/' + uuid, body, cb, errorCb)
}

export {
    findAll,
    statusTypes,
    update
}



// WEBPACK FOOTER //
// ./src/services/projectStatusService.js